import type { ReactNode } from 'react';
import { tSettings } from '../../lib/settings-i18n';

/**
 * 아직 동작하지 않는 설정 행 — **켜지는 척하는 토글을 만들지 않기 위한** 공통 표기.
 *
 * 기존 개인 설정 모달(`PersonalSettingsModal`)이 정보 밀도·애니메이션 항목에서 쓰던
 * "자리는 잡되 disabled + '준비 중'" 관례를 그대로 따른다. 사용자가 눌렀는데 아무 일도
 * 일어나지 않는 것과, 처음부터 준비 중이라고 밝히는 것은 다르다.
 */
export function PendingRow({
  title, desc, icon, control = 'switch',
}: {
  title: string;
  desc: string;
  icon?: ReactNode;
  /** 오른쪽에 둘 표시 — 스위치 모양(기본) 또는 배지만. */
  control?: 'switch' | 'badge';
}) {
  return (
    <div className="st-row st-row--pending">
      {icon && <span className="st-row__ico" aria-hidden>{icon}</span>}
      <span className="st-row__main">
        <span className="st-row__title">{title}</span>
        <span className="st-row__desc">{desc}</span>
      </span>
      {control === 'switch' ? (
        <button
          type="button"
          className="st-switch"
          role="switch"
          aria-checked={false}
          aria-label={`${title} — ${tSettings('settings.modal.pending_badge')}`}
          disabled
        />
      ) : (
        <span className="st-badge">{tSettings('settings.modal.pending_badge')}</span>
      )}
    </div>
  );
}

/** 섹션 머리 — 제목 + 한 줄 설명(재사용). */
export function PanelHead({ title, desc }: { title: string; desc: string }) {
  return (
    <div className="st-head">
      <h2 className="st-head__title">{title}</h2>
      <p className="st-head__desc">{desc}</p>
    </div>
  );
}
